import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    border-inline-end: 0;
  }

  body {
    background: var(--sp-color-surface-page, #e8ecf0);
    color: var(--sp-color-text, #0f1724);
    font-family: var(--sp-font-family, system-ui, sans-serif);
    height: 100%;
  }

  img {
    display: block;
    max-width: 100%;
    user-select: none;
  }

  *::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
  }

  *::-webkit-scrollbar-track {
    background-color: var(--sp-color-surface-page, #e8ecf0);
  }

  *::-webkit-scrollbar-thumb {
    background-color: rgba(15, 23, 36, 0.35);
  }

  .user-validation-modal {
    .ant-modal {
      position: relative;
      margin: 0 auto;
      top: 50%;
      transform: translateY(-50%);
    }
    .ant-modal-content {
      max-width: 400px;
      margin: 0 auto;
    }
  }
`;

export default GlobalStyles;
